// GENERATED FILE. Do not edit by hand. Produced by `bun run codegen`.

import __setDefaultSdkOptions from "../sdk-helpers/__setDefaultSdkOptions";

import createAuditList from "./audit/postAuditList";
import createBannerSet from "./banner/postBannerSet";
import createInviteAccept from "./invite/postInviteAccept";
import createInviteBulkPreview from "./invite/postInviteBulkPreview";
import createInviteBulkSend from "./invite/postInviteBulkSend";
import createInviteDecline from "./invite/postInviteDecline";
import createInviteGet from "./invite/postInviteGet";
import createInviteList from "./invite/postInviteList";
import createInviteRevoke from "./invite/postInviteRevoke";
import createInviteSend from "./invite/postInviteSend";
import createInviteSmsSend from "./invite/postInviteSmsSend";
import createInviteUserSearch from "./invite/postInviteUserSearch";
import createJoinGrantGet from "./joinGrant/postJoinGrantGet";
import createJoinGrantRegenerate from "./joinGrant/postJoinGrantRegenerate";
import createMemberApprove from "./member/postMemberApprove";
import createMemberGet from "./member/postMemberGet";
import createMemberList from "./member/postMemberList";
import createMemberReject from "./member/postMemberReject";
import createMemberRemove from "./member/postMemberRemove";
import createMemberSetRole from "./member/postMemberSetRole";
import createMemberSuspend from "./member/postMemberSuspend";
import createMemberUnsuspend from "./member/postMemberUnsuspend";
import createOwnershipTransfer from "./ownership/postOwnershipTransfer";
import createPoolArchive from "./pool/postPoolArchive";
import createPoolArchiveMine from "./pool/postPoolArchiveMine";
import createPoolCreate from "./pool/postPoolCreate";
import createPoolCreateOptions from "./pool/postPoolCreateOptions";
import createPoolGet from "./pool/postPoolGet";
import createPoolJoin from "./pool/postPoolJoin";
import createPoolJoinPreview from "./pool/postPoolJoinPreview";
import createPoolJoinRequestCancel from "./pool/postPoolJoinRequestCancel";
import createPoolLeave from "./pool/postPoolLeave";
import createPoolListMine from "./pool/postPoolListMine";
import createPoolRulesGet from "./pool/postPoolRulesGet";
import createPoolSearch from "./pool/postPoolSearch";
import createPoolSharedWithAccount from "./pool/postPoolSharedWithAccount";
import createPoolUpdate from "./pool/postPoolUpdate";
import createQuickStartList from "./quickStart/postQuickStartList";
import createShareLinkGet from "./shareLink/postShareLinkGet";

export type SdkOptions = {
  headers?: Record<string, string>;
  apiHost?: string;
  prefix?: string;
};

// Every method is built from RESOLVED options, never the raw argument.
// `sdk()` with no arguments has to work. That is the shape every generated
// hook uses through useCallSdk(), and passing the raw `undefined` through
// gave those methods no apiHost and no "/v1/<zone>" prefix, so they POSTed to
// a bare relative "/resource/action".
export default function sdk(options?: SdkOptions) {
  const resolvedOptions = __setDefaultSdkOptions(options);
  return {
    postAuditList: createAuditList(resolvedOptions),
    postBannerSet: createBannerSet(resolvedOptions),
    postInviteAccept: createInviteAccept(resolvedOptions),
    postInviteBulkPreview: createInviteBulkPreview(resolvedOptions),
    postInviteBulkSend: createInviteBulkSend(resolvedOptions),
    postInviteDecline: createInviteDecline(resolvedOptions),
    postInviteGet: createInviteGet(resolvedOptions),
    postInviteList: createInviteList(resolvedOptions),
    postInviteRevoke: createInviteRevoke(resolvedOptions),
    postInviteSend: createInviteSend(resolvedOptions),
    postInviteSmsSend: createInviteSmsSend(resolvedOptions),
    postInviteUserSearch: createInviteUserSearch(resolvedOptions),
    postJoinGrantGet: createJoinGrantGet(resolvedOptions),
    postJoinGrantRegenerate: createJoinGrantRegenerate(resolvedOptions),
    postMemberApprove: createMemberApprove(resolvedOptions),
    postMemberGet: createMemberGet(resolvedOptions),
    postMemberList: createMemberList(resolvedOptions),
    postMemberReject: createMemberReject(resolvedOptions),
    postMemberRemove: createMemberRemove(resolvedOptions),
    postMemberSetRole: createMemberSetRole(resolvedOptions),
    postMemberSuspend: createMemberSuspend(resolvedOptions),
    postMemberUnsuspend: createMemberUnsuspend(resolvedOptions),
    postOwnershipTransfer: createOwnershipTransfer(resolvedOptions),
    postPoolArchive: createPoolArchive(resolvedOptions),
    postPoolArchiveMine: createPoolArchiveMine(resolvedOptions),
    postPoolCreate: createPoolCreate(resolvedOptions),
    postPoolCreateOptions: createPoolCreateOptions(resolvedOptions),
    postPoolGet: createPoolGet(resolvedOptions),
    postPoolJoin: createPoolJoin(resolvedOptions),
    postPoolJoinPreview: createPoolJoinPreview(resolvedOptions),
    postPoolJoinRequestCancel: createPoolJoinRequestCancel(resolvedOptions),
    postPoolLeave: createPoolLeave(resolvedOptions),
    postPoolListMine: createPoolListMine(resolvedOptions),
    postPoolRulesGet: createPoolRulesGet(resolvedOptions),
    postPoolSearch: createPoolSearch(resolvedOptions),
    postPoolSharedWithAccount: createPoolSharedWithAccount(resolvedOptions),
    postPoolUpdate: createPoolUpdate(resolvedOptions),
    postQuickStartList: createQuickStartList(resolvedOptions),
    postShareLinkGet: createShareLinkGet(resolvedOptions),
  };
}
